var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "account"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.5999 42.5999C33.7332 42.3999 29.0665 37.5999 29.0665 31.6999C29.0665 25.6666 33.9332 20.7666 39.9999 20.7666C46.0332 20.7666 50.9332 25.6666 50.9332 31.6999C50.8999 37.5999 46.2665 42.3999 40.3999 42.5999C40.1665 42.5666 39.8665 42.5666 39.5999 42.5999Z",
    stroke: "#15284C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.0001 73.3335C31.3334 73.3335 23.4668 70.0335 17.5334 64.6002C17.8668 61.4669 19.8668 58.4002 23.4334 56.0002C32.5668 49.9335 47.5001 49.9335 56.5668 56.0002C60.1334 58.4002 62.1334 61.4669 62.4668 64.6002C56.5334 70.0335 48.6668 73.3335 40.0001 73.3335Z",
    stroke: "#15284C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0001 73.3333C21.5906 73.3333 6.66675 58.4095 6.66675 40C6.66675 21.5905 21.5906 6.66666 40.0001 6.66666C58.4096 6.66666 73.3334 21.5905 73.3334 40C73.3334 58.4095 58.4096 73.3333 40.0001 73.3333Z",
    stroke: "#15284C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.27da74434f99567275a51aea3cbbe772.svg";
export { ForwardRef as ReactComponent };